import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast'
import { base_url } from '../Config/config';
import _fetch from '../Config/api';
import { ColorRing } from 'react-loader-spinner';
import { NavLink, useNavigate } from 'react-router-dom';
import dateFormat from "dateformat";
import moment from 'moment';
import { Pagination } from "antd";


const Depositpage = () => {
  const [data, setData] = useState()
  const [balance, setBalance] = useState()
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSer, setpageSer] = useState(0);
  const [wallet, setWallet] = useState()
  const handledashboard = async () => {
    try {
      let response = await _fetch(`${base_url}api/user/dashboard`, 'get', {});
      console.log('resp is ', response)
      if (response.success == true) {
        setBalance(response?.data);

      } else {
        toast.dismiss()
        toast.error(response.message);
      }
    } catch (error) {
      console.log("Error details", error);
    }
  }
  const handlewallet = async (page = 1, pageSize = 10) => {
    try {
      const skip = (page - 1) * pageSize;
      setpageSer(skip);
      const requestData = {
        limit: pageSize,
        skip: skip,
        walletType: "DEPOSIT",
        transactionType: "accountActivation"



      };
      let response = await _fetch(`${base_url}api/user/walletLedgar`, 'post', requestData);
      console.log('resp is ', response)
      if (response.success == true) {
        setWallet(response);

      } else {
        toast.dismiss()
        toast.error(response.message);
      }
    } catch (error) {
      console.log("Error details", error);
    }
  }

  const handleactivateaccount = async (id) => {
    try {
      const requestData = {
        id: id


      };




      let response = await _fetch(`${base_url}api/user/activateAccount`, 'post', requestData);
      console.log('resp is ', response)
      if (response.success == true) {
        setBalance(response?.data);
        toast.success(response.message)
        handledashboard()
      } else {
        toast.dismiss()
        toast.error(response.message);
      }
    } catch (error) {
      console.log("Error details", error);
    }
  }

  const handlepackage = async () => {
    try {


      let response = await _fetch(`${base_url}api/user/packages`, 'GET', {});
      console.log('response ', response)
      if (response.success === true) {
        setData(response);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.log("Error details", error);
    }
  }




  useEffect(() => {
    handlepackage();
    handledashboard()
    handlewallet(currentPage, 10)
  }, [currentPage]);
  const handlePaginationChange = (pageOne) => {
    setCurrentPage(pageOne);

  };
  console.log('wallet', wallet);

  const records = () => {
    if (data && data?.data && data?.data?.length > 0) {
      return data?.data?.map((row, i) => {

        return (
          <>


            <div class=" mt-3 box_main034 col-lg-4 col-md-4 col-sm-6 col-4 ">
              <div class="main-btn p-0">

                <div className="mt-2 "
                  onClick={() => handleactivateaccount(row._id)}
                  style={{ cursor: 'pointer' }}>
                  <div class="btnn_blue">
                    <span className="text-light text-center">${row?.packageAmount}</span>
                    <h1 className="jg">${row?.extra}  Extra</h1>
                  </div>


                </div>


              </div>
            </div>



          </>

        );
      });
    } else {
      return (
        <tr>
          <td colSpan="13" className='text-center text-light m-auto d-flex mt-2'>Data Not Found</td>
        </tr>
      );
    }
  };
  const record = () => {
    if (wallet && wallet?.data && wallet?.data?.length > 0) {
      return wallet?.data?.map((row, i) => {

        return (
          <>
            <div className="container p-1">
              <div className="card p-1">
                <div className="card-body">

                  <div className="row openPositionsDiv">
                    <div className="col-md-6">
                      <dl className="row mb-0 positionRow">
                        <dt className="col-6">Token Name</dt>
                        <dd className="col-6"><small>{row?.tokenName}</small></dd>
                        <dt className="col-6">Amount</dt>
                        <dd className={`col-6 ${row?.amount < 0 ? 'text-danger' : 'text-success'}`}>{row?.amount}</dd>
                        <dt className="col-6">Created At</dt>
                        <dd className="col-6">{dateFormat(row?.createdAt, "yyyy-mm-dd, hh:mm:ss TT")}</dd>

                      </dl>

                    </div>
                    <div className="col-md-6">
                      <dl className="row mb-0 positionRow">
                        <dt className="col-6">Side</dt>
                        <dd className={`col-6 ${row?.side === 'DEBIT' ? 'text-danger' : 'text-success'}`}>
                          {row?.side}
                        </dd>
                        <dt className="col-6">Transaction Type </dt>
                        <dd className="col-6">{row?.transactionType?.toUpperCase()}</dd>
                      </dl>
                    </div>

                  </div>
                </div>
              </div>
            </div>




          </>

        );
      });
    } else {
      return (
        <tr>
          <td colSpan="13" className='text-center text-light m-auto d-flex mt-2'>Data Not Found</td>
        </tr>
      );
    }
  };

  console.log('balance', balance);



  return (
    <>
      <div className="section2">

        <div className="table-sec">
          <div className="transactions">
            <div className="container mt-5 p-1">
              <div className="card back-card">
                <div className='main-12 p-0'>
                  <div className="heading-main">
                    <h1 className='m-0 text-dark main-heading'>Available balance</h1>
                    <h6 className='mb-0 balance text-center mt-2'>
                      Balance : {balance?.depositBalance ? Number(balance?.depositBalance).toFixed(2) : ""}
                    </h6>

                  </div>
                </div>
              </div>
            </div>
            <div className='box_098 row p-1'>
              {records()}
            </div>
            <div className='box_098 row p-1'>
              {record()}
            </div>
            <div className="pagination">
              <Pagination
                style={{ cursor: "pointer" }}
                className="mx-auto"
                current={currentPage || 1}
                total={wallet?.count || 0}
                pageSize={10}
                onChange={handlePaginationChange}
                showSizeChanger={false}
                showQuickJumper={false}
              />

            </div>
          </div>

        </div>
      </div>
    </>
  )
}

export default Depositpage
